export default {
  'Your profile': 'Jouw profiel',
  Settings: 'Instellingen',
  'Sign out': 'Uitloggen',
  Profile: 'Profiel',
  'Activate 2FA': '2FA activeren',
  'Disable 2FA': '2FA uitschakelen',
  Submit: 'Verzenden',
  Date: 'Datum',
  Calendar: 'Kalender',
  'Open popup': 'Open popup',
};
